<template>
    <div>
        <b-card>
          <h3>TMV</h3>
          <br/>
          <b-row>
            <b-col>These questions can be defaulted if no configuration required</b-col>
            <b-col><b-button variant="outline-info" v-on:click="SkipPage()">Use Default Values</b-button></b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col cols="1">Q1</b-col>
            <b-col align="left">Hot In Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.TMV.TMVHot" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q2</b-col>
            <b-col align="left">Cold In Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.TMV.TMVCold" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q3</b-col>
            <b-col align="left">Mixed Out Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.TMV.MixedOut" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <hr/>
          <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>

        </b-card>
    </div>
</template>

<script>
    export default {
      props:['DataPass','Type','ID'],
      data() {
      return {
        stepComplete: false,
        InvalidNum: false,
        Values:{
          TMV: {
              TMVHot: "",
              TMVCold: "",
              MixedOut: ""
                    },
      }
    }
    },
    computed: {},
    components: {},
    mounted(){
      if (this.Type == 'Modify'){
        this.Values.TMV.TMVHot = this.DataPass.TMV.TMVHot
        this.Values.TMV.TMVCold = this.DataPass.TMV.TMVCold
        this.Values.TMV.MixedOut = this.DataPass.TMV.MixedOut
      } else {
        this.Values.TMV.TMVHot = 50.00
        this.Values.TMV.TMVCold = 15.00
        this.Values.TMV.MixedOut = 41.00
      }




       
    },
    methods:{
      CompletePage(){
        if (this.NumberCheck(this.Values) == true){
          alert("Please ensure entries contain only valid numbers")
        } else{
        this.$emit("PageComplete",3,this.Values)
        this.stepComplete = true;
        }
      },
      SkipPage(){
        this.Values.TMV.TMVHot = 50.00
        this.Values.TMV.TMVCold = 15.00
        this.Values.TMV.MixedOut = 41.00
        this.$emit("PageComplete",3,this.Values)
        this.stepComplete = true;
      },
      NumberCheck(data){
        this.InvalidNum = false
        
        let invalidtmvhot = /^\d{1,3}(\.\d+)?$/.test(data.TMV.TMVHot)
        let invalidtmvcold = /^\d{1,3}(\.\d+)?$/.test(data.TMV.TMVCold)
        let invalidtmvmix = /^\d{1,3}(\.\d+)?$/.test(data.TMV.MixedOut)
        
        if (!invalidtmvhot || !invalidtmvcold || !invalidtmvmix){
          this.InvalidNum = true
        }

        return this.InvalidNum
      }
    },

    }
</script>

<style>

</style>